<template>
    <div :id="'gallery__item-' + element.id"
         class="item pb-3 mb-3 border-bottom col-12">

        <transition mode="out-in" name="slide">
            <div v-if="!isEdit"
                 class="row">
                <div class="col-12">
                    <h2 v-if="element.name">{{ element.name }}</h2>
                </div>
                <div class="col-12">
                    <CoolLightBox
                        :index="index"
                        :items="lightBoxImages"
                        @close="index = null">
                    </CoolLightBox>
                    <div class="images-list">
                        <draggable
                            v-model="lightBoxImages"
                            :disabled="!enabled"
                            class="images-wrapper row"
                            ghost-class="ghost"
                            @start="dragging = true"
                            @end="dragStop()"
                        >
                        <div v-for="(image, imageIndex) in lightBoxImages"
                             :key="imageIndex"
                             class="col-2"
                             @click="index = imageIndex">
                            <div :class="image.thumbnail ? 'border border-success' : ''"
                                 :style="{ backgroundImage: 'url(' + image.src + ')' }"
                                 :data-sort="imageIndex"
                                 class="image"
                            >
                            </div>
                        </div>
                        </draggable>
                    </div>
                </div>
                <div class="col-8 d-flex flex-row align-items-center">
                    <div class="img-sort-help mt-3">
                        <i class="fas fa-info-circle"></i> {{ this.help }}
                    </div>
                </div>
                <buttons :isLoading="isLoading"
                         @delete="deleteItem(element.id)"
                         @edit="isEdit = true">
                </buttons>
            </div>

            <gallery-form v-if="isEdit"
                          :item="element"
                          :national-service-options="nationalServiceOptions"
                          :url="this.url"
                          axios-method="PATCH"
                          @addItem="updateItem"
                          @cancelNew="isEdit = false"></gallery-form>
        </transition>
    </div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import GalleryForm from './GalleryForm';
import draggable from 'vuedraggable'

export default {
    name: 'Gallery',
    props: {
        item: Object,
        nationalServiceOptions: Array,
    },

    components: {
        GalleryForm,
        CoolLightBox,
        draggable,
    },

    data() {
        return {
            isLoading: false,
            enabled: true,
            lightBoxImages: [],
            dragging: false,
            index: null,
            isEdit: false,
            url: '/api/merchant/galleries',
            element: this.item,
            help: "Die Bilder können an die gewünschte Position verschoben werden.",
        };
    },
    mounted() {
        this.updateImages(this.item);
    },
    methods: {
        deleteItem(payload) {
            this.$swal({
                title: 'Sind Sie sicher?',
                text: 'Sie können dies nicht rückgängig machen!',
                showDenyButton: true,
                confirmButtonText: `Löschen`,
                denyButtonText: `Nicht löschen`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading = true;
                    axios.delete(this.url + '/' + payload).then((response) => {
                        this.$swal({
                            title: response.data.message,
                        });
                        this.isLoading = false;
                        this.$emit('deleteItem', payload);
                    }).catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Es ist ein Fehler aufgetreten',
                        });
                        this.isLoading = false;
                    });
                }
            });
        },
        dragStop() {
            /**  Add index just to be safe about the image position */
            Array.from(this.lightBoxImages).forEach((element, index, array)=> {
                    this.lightBoxImages[index]['index'] = index;
                }
            );

            axios({
                method: 'PATCH',
                url: '/api/merchant/gallery/order',
                data: this.lightBoxImages,
            }).then((response) => {
                   this.$swal({
                       title: response.data.message,
                   });
            }).catch((error) => {
                this.$swal({
                    icon: 'error',
                    title: 'Es ist ein Fehler aufgetreten',
                });
            });
        },
        updateItem(payload) {
            this.element = payload;
            this.isEdit = false;
            this.$emit('updateItems', payload);
            this.updateImages(payload);
        },
        updateImages(payload) {
            this.lightBoxImages = [];
            if (payload.image && payload.image.length > 0) {
                payload.image.forEach((image) => {
                    this.lightBoxImages.push(
                        {
                            id: image.id,
                            title: image.name,
                            src: image.url,
                            thumbnail: payload.thumbnail_media_id === image.id,
                        },
                    );
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.gallery__preview {
    min-width: 100%;
    height: 150px;
    background-repeat: no-repeat;
    background-size: cover;
}

.image {
    min-height: 100px;
    cursor: move;
}

.ghost {
    opacity: 0.5;
    background: #98c000;
}

.img-sort-help {
    font-size: 0.9rem !important;
    color: #6d6d6d;
}

</style>
